<template>
  <div class="selector-recursos-wrapper">
    <div class="row">
      <div class="col-xs-12">
        <input
          ref="inputFiltroNombre"
          v-model="filtroNombre"
          type="text"
          class="form-control"
          :placeholder="$I18n.t('recurso')"
        />
      </div>
    </div>
    <div class="row m-t text-12x">
      <div class="col-md-12">
        <div
          v-for="categoria in categorias"
          :key="categoria.id"
          class="label-categoria label label-trans m-r-xs"
          :class="{ active: idCategoriaSeleccionada === categoria.id }"
          @click="seleccionCategoria(categoria.id)"
        >
          <i class="fas fa-circle" :style="{ color: categoria.color }"></i> {{ categoria.nombre }}
        </div>
      </div>
    </div>
    <div class="row product-grid fondo-gris m-t p-t-md">
      <div
        v-for="recurso in recursos"
        :key="recurso.id"
        class="col-sm-3 m-b"
      >
        <div
          class="product-box-compact clickable"
          :class="clasesRecurso(recurso)"
          @click="recursoSeleccionado(recurso)"
        >
          <div class="product-box-compact-body">
            <div v-if="recurso.tipo !== 'espacio'" class="count">
              {{ recurso.existencias }}
            </div>
            <img
              class="product-box-compact-image img-responsive img-circle img-thumbnail"
              :src="recurso.foto_url"
            />
            <h3 class="m-b-xs">
              <strong>{{ recurso.nombre }}</strong>
            </h3>
            <div class="font-bold">
              {{ recurso.categoria.nombre }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-actions m-t-sm">
      <button class="btn btn-default" @click.prevent="$emit('cancelado')">
        {{ $I18n.t('Cancelar') }}
      </button>
      <button class="btn btn-cifra" @click.prevent="aceptar">
        {{ $I18n.t('Aceptar') }}
      </button>
    </div>
  </div>
</template>

<script>
import { uniqBy } from 'lodash';
import { recursos } from 'cifra-api-js';
import { match } from '../../../libs/strings';

const NUM_RECURSOS_FILA = 4;

export default {
  props: {
    idsRecursos: { type: Array, default: () => ([]) },
    multiple: { type: Boolean, default: true },
    cerrarAlSeleccionar: { type: Boolean, default: false },
  },
  data() {
    return {
      todosRecursos: [],
      filtroNombre: null,
      idCategoriaSeleccionada: null,
      seleccionados: [],
    };
  },
  computed: {
    recursos() {
      let recursos = this.todosRecursos;
      if (this.idCategoriaSeleccionada) {
        recursos = recursos.filter((recurso) => (
          recurso.categoria.id === this.idCategoriaSeleccionada
        ));
      }
      if (this.filtroNombre) {
        recursos = recursos.filter((recurso) => match(recurso.nombre, this.filtroNombre));
      }
      return recursos;
    },
    categorias() {
      const cats = this.todosRecursos
        .map((recurso) => (recurso.categoria))
        .filter((recurso) => (recurso));

      return uniqBy(cats, 'id');
    },
  },
  mounted() {
    recursos.recursos.list({ params: { reservable: true }}).then((result) => {
      this.todosRecursos = result.data;
      if (this.idsRecursos) {
        this.seleccionados = this.todosRecursos.filter((re) => this.idsRecursos.includes(re.id));
      }
    });
    this.$refs.inputFiltroNombre.focus();
  },
  methods: {
    seleccionCategoria(idCategoria) {
      if (this.idCategoriaSeleccionada === idCategoria) {
        this.idCategoriaSeleccionada = null;
      } else {
        this.idCategoriaSeleccionada = idCategoria;
      }
    },
    recursoSeleccionado(recurso) {
      if (!this.multiple) {
        this.seleccionados = recurso ? [recurso] : [];
      } else if (!this.seleccionados.includes(recurso)) {
        this.seleccionados.push(recurso);
      } else {
        // deseleccionamos
        this.seleccionados = this.seleccionados.filter((rec) => rec !== recurso);
      }
      if (this.cerrarAlSeleccionar) {
        this.aceptar();
      }
    },
    aceptar() {
      this.$emit('aceptado', this.seleccionados);
    },
    clasesRecurso(recurso) {
      return {
        active: this.seleccionados.includes(recurso),
        'product-box-fixed-height': this.recursos.length <= NUM_RECURSOS_FILA,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../../../assets/stylesheets/cifra/vars/main.scss";

  .label-categoria {
    cursor: pointer;
    font-size: 0.8em;

    &.active {
      background-color: $cifra-color;
      color: white;
      border: none;
    }
  }

  // Si son pocos (solo una fila) se estiran para ocupar todo el alto y queda feo,
  // con esta ñapa hacemos que ocupe la mitad y quede más bonito
  .product-box-fixed-height {
    max-height: 260px;
  }
  .selector-recursos-wrapper{
    height: 100%;
    display: flex;
    flex-direction: column;

    .product-grid {
      flex-grow: 1;
      overflow: auto;
    }
  }
</style>
